import React from "react";
import { ArrowRight, Package, Stack } from "@phosphor-icons/react";
import { Card, Empty, Pill, aud, num } from "../ui";
import { DecisionPill } from "../assess/parts";
import { ApprovalPill } from "./parts";

function Row({ r, onOpen }) {
  return (
    <tr onClick={() => onOpen(r)} className="border-b border-neutral-900 hover:bg-white/[0.03] cursor-pointer align-top" data-testid={`wi-approval-queue-row-${r.id}`}>
      <td className="py-2.5 pr-3 whitespace-nowrap"><div className="font-mono text-neutral-100">{r.chassis || "No chassis"}</div><div className="text-neutral-600">{r.claim_date}</div></td>
      <td className="py-2.5 pr-3 text-neutral-300">{r.customer}<div className="text-neutral-600">{r.model} · {r.dealer}</div></td>
      <td className="py-2.5 pr-3 text-right tabular-nums text-[#d9b45b]">{aud(r.quoted_total, 2)}</td>
      <td className="py-2.5 pr-3">
        {r.ai ? <div className="space-y-1"><DecisionPill decision={r.ai.decision} /><div className="text-neutral-600">Confidence {r.ai.confidence}</div></div> : <span className="text-neutral-600">Not assessed</span>}
      </td>
      <td className="py-2.5 pr-3 max-w-[220px]">
        <div className="text-neutral-400">{r.group}</div>
        {r.parts_required && <div className="text-neutral-600 truncate flex items-center gap-1"><Package size={11} className="shrink-0" />{r.parts_required}</div>}
        {r.test && <Pill tone="sky">Sandbox board</Pill>}
      </td>
      <td className="py-2.5 text-right whitespace-nowrap">
        {r.approval ? <ApprovalPill status={r.approval.status} /> : <span className="inline-flex items-center gap-1 text-[#73bf44] font-semibold">Review <ArrowRight size={12} /></span>}
      </td>
    </tr>
  );
}

export function ApprovalQueue({ data, onOpen }) {
  return (
    <Card title={`Waiting for a decision${data ? ` · ${num(data.rows.length)}` : ""}`} icon={Stack} testId="wi-approval-queue">
      {!data ? <div className="h-40 animate-pulse" /> : !data.rows.length ? (
        <Empty>No open Warranty 2.0 claims are waiting for a decision.</Empty>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="text-[0.6rem] uppercase tracking-wider text-neutral-500 text-left">
              <tr className="border-b border-neutral-800"><th className="py-2 pr-3">Chassis</th><th className="py-2 pr-3">Customer</th><th className="py-2 pr-3 text-right">Claimed</th>
                <th className="py-2 pr-3">AI suggestion</th><th className="py-2 pr-3">On Monday</th><th className="py-2" /></tr>
            </thead>
            <tbody>{data.rows.map((r) => <Row key={r.id} r={r} onOpen={onOpen} />)}</tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
